import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link as RouterLink, useLocation } from 'react-router-dom'

import { Button, Fab, Popover, Typography } from '@mui/material'

import { securityWarningFab, warningTriangle } from 'api/apiContstants'
import { RootState } from 'redux/store'

import { useSecurityWarningStyles } from '../../styles'

export const SecurityWarningAlert = () => {
    const { t } = useTranslation()
    const [anchorEl, setAnchorEl] = useState(null)
    const location = useLocation()
    const handleSecurityLocation = () => {
        if (location.pathname === '/settings') {
            setAnchorEl(null)
        }
    }
    const { currentUser } = useSelector((state: RootState) => state.user)

    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const open = Boolean(anchorEl)
    const id = open ? 'simple-popover' : undefined

    const { defaultTwoFactorAuthenticationType } = { ...currentUser }

    const style = useSecurityWarningStyles({
        hideSecurityWarningAlert: defaultTwoFactorAuthenticationType === 'GoogleAuthenticator' ? 'none' : 'flex',
    })

    return (
        <>
            <Fab onClick={handleClick} className={style.securityWarnFab} classes={{ root: style.fabRoot }}>
                <div className={style.pulseButton} />
                <img className="security-warn-fab-img" src={securityWarningFab} alt="warning" />
            </Fab>
            <Popover
                anchorOrigin={{ vertical: 25, horizontal: -75 }}
                classes={{ paper: style.paper, root: style.root }}
                id={id}
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorPosition={{ left: 1150, top: 1150 }}
            >
                <>
                    <article className={style.securityPopoverBody}>
                        <div className={style.securityPopoverContent}>
                            <header className={style.securityPopoverHeader}>
                                <img className={style.securityPopoverImg} src={warningTriangle} alt="" />
                                <Typography className={style.securityPopoverHeading} variant="h4">
                                    {t('SecurityWarningAlert.NotSecureAccount')}
                                </Typography>
                            </header>
                            <div className={style.securityPopoverTextHolder}>
                                <Typography className={style.securityPopoverText} variant="body1">
                                    {t('SecurityWarningAlert.NotSecureAccountParagraph1')}
                                </Typography>
                                <Typography className={style.securityPopoverText} variant="body1">
                                    {t('SecurityWarningAlert.NotSecureAccountParagraph2')}
                                </Typography>
                                <RouterLink to="/settings/security" style={{ textDecoration: 'none' }}>
                                    <Button onClick={handleSecurityLocation} className={style.securityPopoverBtn}>
                                        {t('SecurityWarningAlert.GoToSecurity')}
                                    </Button>
                                </RouterLink>
                            </div>
                        </div>
                    </article>
                </>
            </Popover>
        </>
    )
}

export default SecurityWarningAlert
